import { render, staticRenderFns } from "./Subscription.vue?vue&type=template&id=23dfd45c"
import script from "./Subscription.vue?vue&type=script&lang=js"
export * from "./Subscription.vue?vue&type=script&lang=js"
import style0 from "./Subscription.vue?vue&type=style&index=0&id=23dfd45c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports